import React from 'react';
import { GiftIcon } from 'lucide-react';
import { volumes } from '../data/volumes';
import { bonuses } from '../data/bonuses';
export function WhatYouGet() {
  return <section id="volumes" aria-labelledby="volumes-heading" className="bg-navy-950" data-id="element-204" data-mp="zy98von9jpgs">
      <div className="mx-auto max-w-content px-4 py-20 sm:px-6 lg:py-28" style={{
      paddingTop: "0px",
      paddingBottom: "0px"
    }} data-id="element-205" data-mp="l5fs7zw993aj">
        <div className="max-w-3xl" data-id="element-206" data-mp="1drh19ij64ozj">
          
          <h2 id="volumes-heading" className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-[2.75rem]" style={{
          paddingTop: "12px",
          paddingBottom: "12px",
          marginTop: "15px",
          marginBottom: "15px"
        }} data-id="element-207" data-mp="1dssdm6qoj529">
            দ্য আর্জেন্টাইন মাইন্ডসেট সিস্টেমে আপনি ঠিক কী কী পাচ্ছেন
          </h2>
          <p className="mt-4 text-lg text-white/70" data-id="element-208" data-mp="1wquxk74debt7">
            ৬টি সম্পূর্ণ ভলিউম + ৫টি এক্সক্লুসিভ বোনাস + লাইফটাইম অ্যাক্সেস।
          </p>
        </div>

        <ol className="mt-14 divide-y divide-white/10 border-y border-white/10" data-id="element-209" data-mp="21j5y9c6xq1mt">
          {volumes.map(volume => <li key={volume.number} className="grid grid-cols-[4.5rem_1fr] gap-x-6 gap-y-3 py-8 sm:grid-cols-[5.5rem_1fr] sm:gap-x-8 lg:grid-cols-[5.5rem_18rem_1fr]" style={{
          paddingTop: "15px",
          paddingBottom: "15px"
        }} data-id="element-210" data-mp="2vgc4rpregq2l">
              <img src={volume.cover} alt={`তোমো ${volume.number}-এর কভার: ${volume.title}`} className="w-full rounded-md border border-white/15 object-cover shadow-[0_8px_24px_-12px_rgba(0,0,0,0.9)]" loading="lazy" data-id="element-211" data-mp="30f6r31okswrg" />
              <div data-id="element-212" data-mp="3980fpppwx8hz">
                <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-celeste-400" data-id="element-213" data-mp="396p97i531mn6">
                  তোমো {volume.number}
                </p>
                <h3 className="mt-1.5 font-display text-xl font-extrabold tracking-tight text-white sm:text-2xl" data-id="element-214" data-mp="3j4vapymz8qri">
                  {volume.title}
                </h3>
              </div>
              <p className="col-span-2 text-[15px] leading-relaxed text-white/70 lg:col-span-1" data-id="element-215" data-mp="1ornafrg8fmyh">
                {volume.description}
              </p>
            </li>)}
        </ol>

        <div className="mt-20" data-id="element-216" data-mp="2ehvpbzley8tn">
          <div className="rounded-2xl border border-celeste-500/25 bg-navy-900 p-8 sm:p-10" style={{
          paddingTop: "0px",
          paddingBottom: "0px"
        }} data-id="element-217" data-mp="2igl0rmmw5gan">
            <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-sun" data-id="element-218" data-mp="2sfajfhmm34ry">
              <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-219" data-mp="2xen8m90ygnxp" />
              আজ বিনামূল্যে পাচ্ছেন
            </p>
            <h3 className="mt-3 font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-220" data-mp="31f70oy6o91cz">
              ৫টি এক্সক্লুসিভ বোনাস
            </h3>

            <ul className="mt-8 grid gap-6" style={{
            paddingTop: "0px",
            paddingBottom: "0px"
          }} data-id="element-221" data-mp="3691l63u3pkd4">
              {bonuses.map(bonus => <li key={bonus.number} className="flex gap-4" data-id="element-222" data-mp="3g665rz8at7rt">
                  <img src={bonus.cover} alt={`বোনাস ${bonus.number}-এর কভার: ${bonus.name}`} className="h-24 w-24 shrink-0 rounded-md border border-white/15 object-cover sm:h-28 sm:w-28" loading="lazy" data-id="element-223" data-mp="3l3pu5rypn0xh" />
                  <div data-id="element-224" data-mp="14gzzub62ixyz">
                    <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-sun" data-id="element-225" data-mp="14gq92ld78ms8">
                      বোনাস {bonus.number}
                    </p>
                    <h4 className="mt-1 font-display text-base font-extrabold tracking-tight text-white" data-id="element-226" data-mp="ujlkyfzsmh8s">
                      {bonus.name}
                    </h4>
                    <p className="mt-1 text-sm leading-relaxed text-white/70" data-id="element-227" data-mp="1s96qctp44aqh">
                      {bonus.description}
                    </p>
                    <p className="mt-1 text-sm text-celeste-300" data-id="element-228" data-mp="1igiwa6piokvg">{bonus.detail}</p>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}